module.exports = __webpack_public_path__ + "static/media/Pink 2 2.f63ac359.svg";